// extracted by mini-css-extract-plugin
export default {"input":"PasswordChangeModal_input__ADZtJ","codeInfo":"PasswordChangeModal_codeInfo__gC-Ku"};